import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { mapLanguageToComponentProps } from 'interview/i18n'
import TimedInterviewWrapper from 'interview/components/sequenced-interview/timed-interview-wrapper'
import QuestionAnswerView from './question-answer-view'

const propTypes = {
  i18n: PropTypes.shape({
    sequencedInterview: PropTypes.object,
  }).isRequired,
  jobOpening: PropTypes.shape({
    additionalFormFields: PropTypes.arrayOf(PropTypes.object),
    formSetup: PropTypes.object,
  }).isRequired,
  candidate: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  candidateState: PropTypes.string,
}

const defaultProps = {
  candidateState: '',
}

const mapStateToProps = state => ({
  streaming: state.global.opentok.streaming,
  jobOpening: state.interview.jobOpening,
  candidateState: state.interview.candidate.state,
  candidate: state.candidate,
})

export class SequencedInterviewQuestions extends Component {
  componentDidMount() {
    const { candidate: { uuid }, candidateState } = this.props
    if (candidateState && candidateState === 'networktest') {
      browserHistory.replace(`/sequenced-interview/${uuid}/test`)
    }
  }

  render() {
    return (
      <TimedInterviewWrapper>
        <div className="sequenced-interview-questions">
          <QuestionAnswerView />
        </div>
      </TimedInterviewWrapper>
    )
  }
}

SequencedInterviewQuestions.propTypes = propTypes
SequencedInterviewQuestions.defaultProps = defaultProps

export default connect(
  mapLanguageToComponentProps(mapStateToProps)
)(SequencedInterviewQuestions)
